import { z } from 'zod';
import { useConditionSchema } from './condition/useConditionSchema';
import { ClientDataType, Combinator } from '../types';
import { transformInBetweenDates } from './utils/transformations';

export const useRequirementSchema = () => {
  const conditionSchema = useConditionSchema();
  return z
    .object({
      dataType: z.nativeEnum(ClientDataType),
      maxMatch: z.number().max(999).optional(),
      minMatch: z.number().min(1).optional(),
      searchCombo: z.object({
        combinator: z.nativeEnum(Combinator),
        searchQueries: z.array(conditionSchema),
      }),
    })
    .transform(transformInBetweenDates);
};
